/**
 * JavaScript injection utilities for pre-filling Form.io WebView fields
 * and adding blue border highlighting for AI-filled fields.
 * @module features/voice-report/utils/webViewInjection
 */

/**
 * Builds a JavaScript string to inject into the Form.io WebView.
 * Sets form field values and adds blue borders to AI-filled fields.
 * Each field gets a one-time input listener that removes the blue
 * border when the scout manually edits it.
 * @param data - Structured form field values to inject
 * @param aiFilledKeys - Field keys that were AI-populated
 * @returns JavaScript string for webViewRef.injectJavaScript()
 */
export const buildInjectionScript = (
  data: Record<string, unknown>,
  aiFilledKeys: readonly string[]
): string => `
  (function() {
    var form = Formio.forms[Object.keys(Formio.forms)[0]];
    if (!form) return;

    form.submission = {
      data: Object.assign({}, form.submission.data, ${JSON.stringify(data)})
    };

    var style = document.createElement('style');
    style.textContent = '.ai-filled { border: 2px solid #007aff !important; border-radius: 4px; transition: border-color 0.2s; }';
    document.head.appendChild(style);

    ${JSON.stringify(aiFilledKeys)}.forEach(function(key) {
      var el = document.querySelector('[name="data[' + key + ']"]');
      if (el) {
        el.classList.add('ai-filled');
        el.addEventListener('input', function() {
          this.classList.remove('ai-filled');
        }, { once: true });
      }
    });
  })();
`;
